import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useSettingParams } from '../../../common/filterCompany/useSettingParams'
import { Element } from '../../../common/html/element'
import { Loading } from '../../../common/loading'
import { Panel } from '../../../common/panel'
import { SCREEN } from '../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../common/selectCurrencyUnit/useFormatCurrency'
import { SelectCustom } from '../../../common/selectCustom'
import { PORTFOLIO_SCROLL_ID } from '../../common/Layout'
import { selectPeriod } from '../../common/period/slice'
import { CreditRisk } from './CreditRisk'
import { Performance } from './Performance'
import { MODEL_ID, VIEW_BY } from './constant'
import {
  changeViewBy,
  resetStorePortfolioTopHighest,
  selectLoading,
  selectViewBy,
} from './store/slice'
import {
  exportTopHighestScore,
  getTopHighestIndustry,
  getTopHighestPortfolio,
} from './store/thunk'

export const TopHighest = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const viewBy = useSelector(selectViewBy)
  const period = useSelector(selectPeriod)
  const settingParams = useSettingParams()
  const { currency } = useFormatCurrency(SCREEN.PORTFOLIO_INSIGHTS)
  const isLoading = useSelector(selectLoading())

  useEffect(() => {
    if (!settingParams) return
    dispatch(
      getTopHighestPortfolio({
        ...settingParams,
        currency,
        timeFrequency: period,
        modelId: MODEL_ID.CORPORATE_RISK,
      }),
    )
    dispatch(
      getTopHighestPortfolio({
        ...settingParams,
        currency,
        timeFrequency: period,
        modelId: MODEL_ID.PERFORMANCE,
      }),
    )
    dispatch(
      getTopHighestIndustry({
        ...settingParams,
        currency,
        timeFrequency: period,
        modelId: MODEL_ID.CORPORATE_RISK,
      }),
    )
    dispatch(
      getTopHighestIndustry({
        ...settingParams,
        currency,
        timeFrequency: period,
        modelId: MODEL_ID.PERFORMANCE,
      }),
    )
  }, [settingParams, period, currency, locale])

  useEffect(() => {
    return () => dispatch(resetStorePortfolioTopHighest())
  }, [])

  const viewByList = Object.keys(VIEW_BY).map((key) => ({
    label: <Translate value={`portfolio.summary.${key}`} />,
    value: VIEW_BY[key],
  }))

  const chooseItem = (item) => {
    dispatch(changeViewBy(item.value))
  }

  const downloadCsv = {
    downloadFunc: () =>
      exportTopHighestScore({
        ...settingParams,
        currency,
        timeFrequency: period,
        modelId:
          viewBy === VIEW_BY.CREDIT_RISK_SCORE
            ? MODEL_ID.CORPORATE_RISK
            : MODEL_ID.PERFORMANCE,
      }),
    disabled: !settingParams || isLoading,
  }

  const renderLabel = () => (
    <>
      &nbsp;
      <Translate
        value="portfolio.summary.FILTER_ARE_NOT_APPLIED"
        className="fstItalic"
        style={{ textTransform: 'none' }}
      />
    </>
  )

  const renderRightHeader = () => (
    <Element className="dFlex alignItemsCenter" style={{ color: '#3A414B' }}>
      <Translate value="financialAnalysis.VIEW_BY" />
      <SelectCustom
        isBorderNone
        isI18n
        className="fw600"
        data={viewByList}
        activeItem={{ value: viewBy }}
        chooseItem={chooseItem}
        scrollElementIds={[PORTFOLIO_SCROLL_ID]}
      />
    </Element>
  )

  return (
    <Panel
      label={`portfolio.summary.${
        viewBy === VIEW_BY.CREDIT_RISK_SCORE
          ? 'TOP_10_HIGHEST_RISK'
          : 'TOP_10_HIGHEST_GROWTH_POTENTIAL'
      }`}
      isI18n
      renderLabel={renderLabel}
      renderRightHeader={renderRightHeader}
      className="positionRelative"
      headerStyle={{ textTransform: 'capitalize' }}
      downloadCsv={downloadCsv}
    >
      {isLoading && <Loading />}
      <div className="wh100" style={{ opacity: isLoading ? 0 : 1 }}>
        {viewBy === VIEW_BY.CREDIT_RISK_SCORE ? (
          <CreditRisk />
        ) : (
          <Performance />
        )}
      </div>
    </Panel>
  )
}
